<template>

  <t-wrapped :show="cols !== '' || formInline">


    <div :class="{['col-md-'+cols]:cols!=='','button-form-inline':formInline}">

      <b-button :id="'btn-'+text"
                :class="{'btn-shadow':primary || outlinePrimary,'btn-submit':submit,'no-icon':noIcon,'sending':sending,'is-button-primary-invalid':isInvalid, 'button-disabled':!hasAccess}"
                @click="onClick"
                :disabled="localDisabled || sending || disabledSubmitButton"
                :title="localTitle"
                :size="localSize"
                :target="target"
                v-b-tooltip.hover="localTitle"
                :type="type" :to="to && to.length > 0 ? localTo : null" :variant="variant">

        <slot>

          <span class="d-flex" v-if="submit">

             <span class="mr-2" v-if="isInvalid">
               <b-tooltip :target="'btn-'+text" :title="t('msg-check-all-errors-before-continued')"></b-tooltip>
                <i class="icon icon ion-android-close opacity-7" style="color: #FFFFFF"></i>
            </span>

            <span class="mr-2" v-else-if="!sending && !noIcon">
              <i v-if="danger" class="icon icon-anim-pulse icon ion-android-close opacity-7"></i>
              <i v-else class="icon icon-anim-pulse icon ion-android-done-all opacity-7"></i>
            </span>

            <div class="img-loading" v-else-if="sending">

              <div class="loader">
                <div class="ball-clip-rotate-multiple">
                  <div style="width: 15px; height: 15px; left: 0px; top:0px; border-color: #00f0bd"></div>
                  <div
                      style="width: 15px; height: 15px; left: 0px; top: 0px; border-color: #00f0bd"></div>
                </div>
              </div>

            </div>

            {{ command | commandLabel }} {{ text }}

          </span>

          <span v-else>
             <template v-if="hasIcon">
               <b-icon-list v-if="iconList"/>
               <b-icon-pencil v-else-if="iconPencil"/>
               <b-icon-search v-else-if="iconSearch"/>
               <b-icon-plus style="scale:1.4; height: 19px" v-else-if="iconPlus"/>
            </template>
            {{ command | commandLabel }} {{ text }}
          </span>


        </slot>


        <div style="position: relative; float: right; width: 25px" class="fade-enter-active"
             v-if="!submit && sending && enableLoader">

          <div class="loader" style="position: absolute; right: 10px; top:0px">
            <div class="ball-clip-rotate-multiple">
              <div style="width: 15px; height: 15px; left: 0px; top:0px; border-color: #575757"></div>
              <div
                  style="width: 15px; height: 15px; left: 0px; top: 0px; border-color: #d2d2d2"></div>
            </div>
          </div>

        </div>


      </b-button>

    </div>

  </t-wrapped>

</template>
<script>
export default {
  name: 't-button',
  data() {
    return {
      type: "button",
      variant: "",
      hasIcon: false,
      localDisabled: false,
      localSize: "",
      localTitle: "",
      localTo: {},
    }
  },
  props: {
    formInline: Boolean,
    sending: Boolean,
    enableLoader: Boolean,
    small: Boolean,
    large: Boolean,
    target: {
      type: String,
      default: "none",
    },
    cols: {
      type: String,
      default: ""
    },
    command: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    to: {
      type: String,
      default: "",
    },
    title: { //tipForm tipform
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "",
    },
    hasAccess: {
      type: Boolean,
      default: true
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    isInvalid: Boolean,
    submit: Boolean,
    submitFake: Boolean,
    primary: Boolean,
    secondary: Boolean,
    danger: Boolean,
    success: Boolean,
    warning: Boolean,
    focus: Boolean,
    light: Boolean,
    outlinePrimary: Boolean,
    outlineSecondary: Boolean,
    outlineDanger: Boolean,
    outlineSuccess: Boolean,
    outlineWarning: Boolean,
    outlineFocus: Boolean,
    outlineLight: Boolean,
    iconSearch: Boolean,
    iconList: Boolean,
    iconPlus: Boolean,
    iconPencil: Boolean,
    iconDetail: Boolean,
  },
  mounted() {
    this.applyRules()
  },
  watch: {
    hasAccess() {
      this.applyRules()
    },
    primary() {
      this.applyRules()
    },
    secondary() {
      this.applyRules()
    },
    danger() {
      this.applyRules()
    },
    success() {
      this.applyRules()
    },
    warning() {
      this.applyRules()
    },
    disabled() {
      this.applyRules()
    },

  },
  methods: {
    onClick() {
      this.$emit("click")
    },
    applyRules() {

      this.localDisabled = this.disabled
      this.localTitle = this.title


      if (this.small) {
        this.localSize = "sm"
      } else if (this.large) {
        this.localSize = "lg"
      } else {
        this.localSize = "md"
      }

      if (!this.hasAccess) {
        //Não possui acesso, desabilita e insere o tipform indicando que não possui acesso
        //this.localDisabled = true
        this.localTitle = this.t('notHaveAccess')
      }

      if (this.to.length > 0 && this.hasAccess) {
        this.localTo.name = this.to
      }

      if (this.submit && !this.submitFake) {
        this.type = "submit"
      }

      if (this.iconList || this.iconPlus || this.iconPencil || this.iconSearch) {
        this.hasIcon = true
      }

      if (this.hasIcon && this.text.length === 0) {
        //Valor padrão quando há somente ícone sem texto
        this.variant = "outline-secondary"

      } else {
        //Valor padrão quando não há ícones utilizados
        this.variant = "outline-primary"
      }

      if (this.primary) {
        this.variant = "primary"
      } else if (this.secondary) {
        this.variant = "secondary"
      } else if (this.danger) {
        this.variant = "danger"
      } else if (this.success) {
        this.variant = "success"
      } else if (this.warning) {
        this.variant = "warning"
      } else if (this.focus) {
        this.variant = "focus"
      } else if (this.light) {
        this.variant = "light"
      } else if (this.outlinePrimary) {
        this.variant = "outline-primary"
      } else if (this.outlineSecondary) {
        this.variant = "outline-secondary"
      } else if (this.outlineDanger) {
        this.variant = "outline-danger"
      } else if (this.outlineWarning) {
        this.variant = "outline-warning"
      } else if (this.outlineFocus) {
        this.variant = "outline-focus"
      } else if (this.outlineLight) {
        this.variant = "outline-light"
      }

    }

  },

  computed: {

    disabledSubmitButton() {

      if (this.type === 'submit') {
        return this.$store.getters.getDisabledButtonSubmit
      } else {
        return false
      }

    },
  }
}
</script>
<style>
.button-disabled:hover {
  cursor: auto !important;
}

.btn-outline-primary.button-disabled {
  color: #333;
}

.btn-outline-primary.button-disabled:hover {
  background-color: #e1e1e1 !important;
  color: #676767;
}

.is-button-primary-invalid {
  border-color: #d92550 !important;
  background-color: #d92550 !important;
  opacity: 0.8 !important;
}

.btn-submit:not(.no-icon) {
  padding-left: 30px !important;
  padding-right: 35px;
}

.btn-submit.no-icon {
  padding-left: 15px !important;
}

.btn-submit.sending:not(.no-icon) {
  padding-left: 51px !important;
}

.btn-submit.sending.no-icon {
  padding-left: 51px !important;
}

.btn-submit.sending.no-icon .ball-clip-rotate-multiple div {
  border-color: #6f30ff !important;
}

.btn-submit.btn-outline-primary.sending {
  background-color: #f1f1f1;
}


.btn-submit .img-loading {
  width: 25px;
  height: 25px;
  position: absolute;
  left: 28px;
  top: 9px;
  transition: all 0.5s ease-in-out;
}


.btn-submit .img-loading img {
  position: absolute;
  left: -25px;
  top: -12px;
  width: 45px;
  height: 45px;
}


.button-form-inline {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .button-form-inline {
    margin-top: 21px;
  }
}

</style>
